export const riceMill = [
    "MFG250",
    "CC80N1",
    "CCN100",
    "CR80N1",
    "RP150",
    "RP150 DUAL FUNCTION",
    "CM-201",
    "CCS100H",
    "SB100",
  ];
  
  export const multiFunction = ["FC255", "WC155", "CT155"];
  
  export const longTail = ["T-RM", "T-RL", "BIG", "MID", "FW-RV", "T-RM HEAVY"];
  